enum CarrierStatus {
    requested = 1,
    active = 2,
    blocked = 3,
    deleted = 4,
}

export default CarrierStatus;
